export enum LocationViewType {
    Map, List
}